import { render, staticRenderFns } from "./doctorDetail.vue?vue&type=template&id=373f01fa&scoped=true&"
import script from "./doctorDetail.vue?vue&type=script&lang=js&"
export * from "./doctorDetail.vue?vue&type=script&lang=js&"
import style0 from "./doctorDetail.vue?vue&type=style&index=0&id=373f01fa&lang=scss&scoped=true&"
import style1 from "./doctorDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373f01fa",
  null
  
)

export default component.exports